import ApiClient from "@/api/ApiClient";
import type { Window as WindowType } from "@/types/window";

const store = (window as WindowType).store;

type Operator = {
  idCallcenter: number;
  deleted?: string;
  id: number;
  name: string;
  user: string;
  credentials?: string;
  data?: {
    isFixed?: boolean;
    codeAuth?: string;
  };
  rol: number;
  rolText: string;
  validationPhone?: string;
};

export async function getOperators(ccId: number) {
  try {
    return await ApiClient()
      .get<Operator[]>("operators", {
        params: {
          ccenterId: ccId ?? store.getters["app/callCenter"].id,
        },
      })
      .then((response) => response.data);
  } catch (error: unknown) {
    console.error("Error getting operators", error instanceof Error ? error.message : error);
    throw error;
  }
}

export default {
  getOperators,
};
